import React, {useContext} from "react";
import {CardOptions, TextLink, ButtonOption, OrComponent, ContainerButtons, InputAuth, FormAuth, MoreForm, LabelAuth} from "./AuthStyles";
import {ReactComponent as FacebookIcon} from "../../../assets/icons/facebook.svg";
import {ReactComponent as GoogleIcon} from "../../../assets/icons/google-plus.svg";
import Color from "../../../assets/Colors";
import ButtonSocial, {ButtonSocialFb} from "./ButtonSocial";
import Checker from "./Checker";
// import FacebookLogin from "react-facebook-login";
import {GlobalContext} from "../../../context/GlobalContext";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";
import Text from "../../../styles/Text";

export default function LoginOptions({doLogin, errorLogin, errorSocial}) {
   // const {fbLogin} = useContext(GlobalContext);

   function fbLogin(resp) {
      console.log(resp);
      const {first_name, email, last_name, userID} = resp;
      let dataLogin = {first_name, email, last_name, userID, pwd: userID};
      doLogin(dataLogin, true, "fb");
   }
   function gooLogin(resp) {
      let {googleId, imageUrl, email, name, givenName, familyName} = resp.profileObj;
      let dataLogin = {first_name: givenName, email: email, last_name: familyName, userID: googleId, pwd: googleId};
      console.log(dataLogin);
      doLogin(dataLogin, true, "google");
   }

   function simpleLogin(e) {
      e.preventDefault();

      let email = e.target.email.value;
      let pwd = e.target.password.value;
      let remember = e.target.remember.checked;
      let data = {
         email,
         pwd,
      };
      doLogin(data, remember);
      // console.log(email, pwd, remember);
   }
   return (
      <CardOptions>
         <div className="head">
            <TextLink to="/registro">Crear cuenta aquí.</TextLink>
         </div>

         <ContainerButtons>
            <FacebookLogin
               appId="241705067022446"
               // autoLoad
               callback={fbLogin}
               fields="first_name,email,last_name"
               render={(renderProps) => (
                  <ButtonSocial action={renderProps.onClick} Icon={FacebookIcon} title="iniciar sesión con facebook" />
               )}
            />
            {/* <ButtonSocial action={() => console.log("dsad")} Icon={GoogleIcon} title="iniciar sesión con google" /> */}

            <GoogleLogin
               clientId="950896258717-oo4nrjjlbpgn52q5lph1lmnjm526q0vo.apps.googleusercontent.com"
               render={(renderProps) => (
                  <ButtonSocial action={() => renderProps.onClick()} Icon={GoogleIcon} title="iniciar sesión con google" />
               )}
               buttonText="Login"
               onSuccess={gooLogin}
               onFailure={gooLogin}
               cookiePolicy={"single_host_origin"}
            />
         </ContainerButtons>
         {errorSocial && (
            <Text color="crimson" style={{marginTop: "1.5em"}}>
               {errorSocial}
            </Text>
         )}
         <OrComponent />
         <FormAuth onSubmit={simpleLogin}>
            <TextLink visibleborder="none" as="label">
               Inicia sesión con tu correo electrónico
            </TextLink>
            <InputAuth placeholder="Correo electrónico*" type="email" required name="email" />
            <InputAuth placeholder="Contraseña*" type="password" required name="password" />
            <MoreForm>
               <Checker name="remember" title="Recúerdame" />

               <TextLink visibleborder="none" color={Color.secondary} to="/recuperar_contraseña">
                  Olvide mi contraeña
               </TextLink>
            </MoreForm>
            {errorLogin && (
               <Text color="crimson" style={{marginTop: "1.5em"}}>
                  {errorLogin}
               </Text>
            )}
            <ContainerButtons width="40%">
               <ButtonOption className="widthAuto">Iniciar sesión</ButtonOption>
            </ContainerButtons>
         </FormAuth>
      </CardOptions>
   );
}
